// 담임목사 청빙 인재풀 선택지 — server/routers/pastor/pastorFlow.js 의 OPTIONS 와 같은 값
import { religiousbodyList, locationList } from '../../DefaultData';

export const DENOMINATIONS = religiousbodyList;
export const SIDOS = locationList;

export const REGION_TYPES = ['수도권', '광역시', '지방 중소도시', '농어촌', '도서·산간', '해외'];

export type RuralCalling = 'YES' | 'OPEN' | 'NO';
export const RURAL_CALLING: { value: RuralCalling; label: string; desc: string }[] = [
  { value: 'YES', label: '적극 희망합니다', desc: '지방·농어촌 교회를 섬기는 것이 저의 소명입니다' },
  { value: 'OPEN', label: '조건이 맞으면 가능합니다', desc: '사택·생활 여건이 갖춰지면 기쁘게 가겠습니다' },
  { value: 'NO', label: '현재는 어렵습니다', desc: '가족·건강 등의 사정으로 도시 지역을 희망합니다' },
];
export const RURAL_LABEL: Record<string, string> = { YES: '지방·농어촌 적극 희망', OPEN: '지방·농어촌 조건부 가능', NO: '도시 지역 희망' };

export const CHURCH_SIZES = ['30명 이하', '30~50명', '50~100명', '100~300명', '300명 이상'];
export const NEEDS = ['사택', '사례비 협의', '교단 연금', '국민연금·4대보험', '자녀 교육 지원', '차량 지원', '은퇴 후 거처', '사모 사역 자유'];
export const AVAILABLE_FROM = ['즉시', '3개월 이내', '6개월 이내', '1년 이내', '협의'];
export const PHILOSOPHY = ['말씀 중심', '기도 중심', '예배 회복', '전도·선교', '다음세대', '제자훈련', '공동체·소그룹', '지역사회 섬김', '치유·회복', '노년 목회', '다문화 목회', '교회 개척·재건'];
export const STRENGTHS = ['강해설교', '심방·돌봄', '교육·양육', '찬양·예배 인도', '행정·재정', '건축·리모델링', '갈등 회복', '청년 사역', '노인 사역', '귀농·농사 경험', '어린이 사역', '지역 연합 사역'];
export const ROLES = ['담임목사', '부목사', '교육목사', '선교사', '기관목사', '강도사·전도사', '휴직·안식 중'];

export const AGE_BANDS = ['30대', '40대', '50대', '60대'];
export const MIN_YEARS = [
  { value: '', label: '경력 무관' },
  { value: '5', label: '5년 이상' },
  { value: '10', label: '10년 이상' },
  { value: '15', label: '15년 이상' },
  { value: '20', label: '20년 이상' },
];

export const KEYWORD_MAX = 5;

// 청빙 대행 상담 — 전화번호를 정하면 여기에 적는다 (비어 있으면 전화 버튼을 숨김)
export const CONSULT_PHONE: string = '';
export const KAKAO_CHANNEL_URL = 'http://pf.kakao.com/_Xzwrn';
